import React, { Suspense } from 'react';
import { usePermissions } from '../hooks/usePermissions';

const NotFound = React.lazy(() => import('../pages/NotFound'));

interface PermissionGuardProps {
  permission: string;
  children: React.ReactElement;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({ permission, children }) => {
  const { hasPermission } = usePermissions();

  if (!hasPermission(permission)) {
    return (
      <Suspense fallback={<div />}>
        <NotFound />
      </Suspense>
    );
  }

  return children;
};

export default PermissionGuard;
